
// redux (action-types)
import {CHANGE} from 'redux/reducers/exam/content/questions/question/workings/action-types'


const saveWorkings = (questionId, value) => ({type: CHANGE, questionId, value});


export {saveWorkings}